// 退改签信息格式化
const allowPersonType = ['ADT','CHD']
function formatRuleInfo(data) {
    let result = [[],[]];// 第一程，第二程
    if (!data || !data.length) return result;
    data.map((item,index) => {
        item.ruleRootList && item.ruleRootList.length && item.ruleRootList.map(rule => {
            // 过滤非成人、儿童的规则
            if (allowPersonType.indexOf(rule.psgType) === -1) return
            let dataTmp = {};
            dataTmp.psgType = rule.psgType === 'ADT' ? '成人' : '儿童'; 
            dataTmp.cabinCodes = rule.cabinCodes;
            dataTmp.endorsementext = rule.ruleInfosEndorsement && rule.ruleInfosEndorsement.length && rule.ruleInfosEndorsement[0].endorsementext;
            dataTmp.ruleRemark = rule.ruleInfos && ruleRemarkFormart(rule.ruleInfos) || '';
            dataTmp.list = rule.ruleInfos || [];
            if (index === 0) {
                result[0].push(dataTmp);
            } else {
                result[1].push(dataTmp);
            }
        })
    })
    return result
}
function ruleRemarkFormart(ruleInfos) {
    let result = '';
    ruleInfos.map((item,index) => {
        if (index === 0) {
            result += item.ruleRemark ? '退票：' + item.ruleRemark : '';
        } else if (index === 1) {
            result += item.ruleRemark ? '</br>改签：' + item.ruleRemark : '';
        }
    })
    return result
}

module.exports = {
    formatRuleInfo
}